export default __webpack_public_path__ + "0e2e1e4b1ac6898e0a4e2a6b4a98056f.woff2";